// Material Dashboard 2 React Base Styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { inputBorderColor, info, grey, transparent, inputColors, white } = colors;
const { borderWidth, borderRadius } = borders;
const { size } = typography;

const inputOutlined = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      fontSize: size.sm,
      borderRadius: borderRadius.md,
      border: `${borderWidth[0]} solid ${inputColors.borderColor.main} !important`,
      backgroundClip: "padding-box !important",
      color: `${grey[700]} !important`,

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: inputColors.borderColor.main,
      },

      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: info.main,
        },
      },
    },

    notchedOutline: {
      borderColor: inputColors.borderColor.main,
    },

    input: {
      color: grey[700],
      padding: pxToRem(12),
      backgroundColor: transparent.main,
    },

    inputSizeSmall: {
      fontSize: size.xs,
      padding: pxToRem(10),
    },

    multiline: {
      color: grey[700],
      padding: 0,
    },
  },
};

export default inputOutlined;
